module.exports = __webpack_public_path__ + "static/gallery-img-28-3e73b038aafa0e51d153d21a31081b05.jpg";